import { Pipe, PipeTransform } from '@angular/core';

/** The three field-name conventions the pipe accepts, tried in this order. */
interface InitialsSource {
  firstName?: string | null;
  lastName?: string | null;
  vorname?: string | null;
  nachname?: string | null;
  additionalOne?: string | null;
  additionalTwo?: string | null;
}

@Pipe({
  name: 'getInitials',
})
export class GetInitialsPipe implements PipeTransform {
  public transform(user: InitialsSource | null | undefined): string {
    if (user && user.firstName && user.lastName) {
      return user.firstName.substring(0, 1) + user.lastName.substring(0, 1);
    } else if (user && user.vorname && user.nachname) {
      return user.vorname.substring(0, 1) + user.nachname.substring(0, 1);
    } else if (user && user.additionalOne && user.additionalTwo) {
      return user.additionalOne.substring(0, 1) + user.additionalTwo.substring(0, 1);
    }
    return '-';
  }
}
